import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { LeafElement } from "../leaf-element.js";
import { LeafIcon } from "../icon/icon.component.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.leaf-c-validation-message--success {\n  color: var(--leaf-color-content-success);\n}\n\n.leaf-c-validation-message--error {\n  color: var(--leaf-color-content-error);\n  gap: var(--leaf-spacing-8);\n}\n\n.leaf-c-validation-message {\n  align-items: center;\n  display: flex;\n  line-height: normal;\n}\n\n:host {\n  display: block;\n  margin-left: var(--leaf-spacing-4);\n  margin-top: var(--leaf-spacing-4);\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _LeafValidationMessage = class _LeafValidationMessage extends e(LeafElement) {
  constructor() {
    super(...arguments);
    this.variant = "default";
  }
  render() {
    const componentClassName = {
      "leaf-c-validation-message": true,
      "leaf-c-validation-message--success": this.variant === "success",
      "leaf-c-validation-message--error": this.variant === "error"
    };
    return html`<div class=${classMap(componentClassName)}>
      ${this.variant === "error" ? html`<leaf-icon set="system" name="warning"></leaf-icon>` : ""}
      <slot></slot>
    </div>`;
  }
};
_LeafValidationMessage.styles = unsafeCSS(styles);
_LeafValidationMessage.elementDefinitions = {
  "leaf-icon": LeafIcon
};
let LeafValidationMessage = _LeafValidationMessage;
__decorateClass([
  property({ reflect: true })
], LeafValidationMessage.prototype, "for", 2);
__decorateClass([
  property()
], LeafValidationMessage.prototype, "variant", 2);
export {
  LeafValidationMessage
};
//# sourceMappingURL=validation-message.component.js.map
